<template>
  <v-app-bar app color="primary" dark height="70">
    <v-app-bar-nav-icon @click="$emit('toggle-drawer')" class="mr-4"></v-app-bar-nav-icon>

    <v-toolbar-title class="d-flex justify-center flex-grow-1">
      <v-img contain transition="fade-transition" max-height="60" alt="TinyGS logo" src="../../assets/logo.svg" />
    </v-toolbar-title>

    <div class="d-none d-md-flex align-center">
      <v-btn icon class="mr-2" v-if="user" @click="navigateToUser">
        <v-icon large>mdi-account-circle</v-icon>
      </v-btn>
      <v-btn @click="$emit('logout')" color="primary" class="lighten-1 mr-2" depressed v-if="user">
        <span>Sign Out</span>
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn>
      <v-btn v-if="!user" color="primary" class="lighten-1 mr-2" @click="$emit('open-login')">
        <v-icon left>mdi-login</v-icon> <span class="d-none d-lg-inline">Login</span>
      </v-btn>
      <v-btn v-if="!user" color="primary" class="lighten-1 mr-2" @click="$emit('open-register')">
        <v-icon left>mdi-account-plus</v-icon> <span class="d-none d-lg-inline">Register</span>
      </v-btn>
      <v-btn
        color="primary"
        class="lighten-1 ml-2"
        href="https://www.paypal.com/donate/?hosted_button_id=P3ZY6B9AQEFZA"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://static.tinygs.com/PayPal.png"
          alt="PayPal"
          height="20"
          style="vertical-align: middle; margin-right: 5px;"
        />
        Donate
      </v-btn>
    </div>

    <div class="d-flex d-md-none">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="user" @click="navigateToUser">
            <v-list-item-icon>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="user" @click="$emit('logout')">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!user" @click="$emit('open-login')">
            <v-list-item-icon>
              <v-icon>mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!user" @click="$emit('open-register')">
            <v-list-item-icon>
              <v-icon>mdi-account-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Register</v-list-item-title>
          </v-list-item>
          <v-list-item href="https://www.paypal.com/donate/?hosted_button_id=P3ZY6B9AQEFZA" target="_blank" rel="noopener noreferrer">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Donate</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { getCurrentInstance } from 'vue'

export default {
  name: "NavToolbar",
  props: {
    user: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const { proxy } = getCurrentInstance()
    const router = proxy.$router
    
    const navigateToUser = async () => {
      const targetRoute = `/user/${props.user}`
      
      // Skip navigation if already on target route
      if (proxy.$route.path === targetRoute) {
        return
      }

      try {
        await router.push(targetRoute)
      } catch (err) {
        // Only ignore NavigationDuplicated errors
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
          throw err
        }
      }
    }

    return {
      navigateToUser
    }
  }
}
</script>